import { PropsWithChildren, useEffect, useState } from 'react';
import { useTranslation } from 'next-i18next';
import { InterestsSchema, MergeFieldSchema } from '../../lib/api/marketing.api';
import CheckboxControl from '../form-controls/controls/CheckboxControl';
import InputTextControl from '../form-controls/controls/InputTextControl';
import SelectControl from '../form-controls/controls/SelectControl';
import Label from '../form-controls/label/Label';

interface Props {
    schema: InterestsSchema
    mergeFields: MergeFieldSchema;
}
const JoinTeacherTribeForm: React.FC<Props> = ({ schema, mergeFields }) => {

    if (!(schema && schema.categories)) return null;

    const { t } = useTranslation();

    const visibleCategories = [
        'Levels',
        'Region',
    ];

    const [knowFromChoices, setKnowFromChoices] = useState([]);

    useEffect(() => {
        const choices = mergeFields.merge_fields.find(val => val.tag === 'KNOW_FROM').options.choices
            .map(choice => ({
                label: t(`common:knowFromValues.${choice}`, { defaultValue: choice }),
                value: choice,
            }));
        setKnowFromChoices(choices);
    }, [mergeFields])

    return (
        <>
            <InputTextControl name="email"
                label={t('common:personalInformations.emailAddress')}
                required
            />
            <div className="flex flex-col justify-between lg:flex-row lg:space-x-6">
                <InputTextControl name="firstName"
                    required
                    label={t('common:personalInformations.firstName')}
                />
                <InputTextControl name="lastName"
                    required
                    label={t('common:personalInformations.lastName')}
                />
            </div>

            {schema.categories
                .filter(category => visibleCategories.includes(category.title))
                .map(category => (
                    <Category key={category.id} category={category}></Category>
                ))}

            <Label label={t('join-teacher-tribe:knowFrom')} name="knowFrom" />
            <SelectControl
                name="knowFrom"
                placeholder={t('join-teacher-tribe:knowFromPlaceholder')}
                options={knowFromChoices}
            />
        </>
    )
}

export default JoinTeacherTribeForm;


type GetElementType<T extends Array<any>> = T extends (infer U)[] ? U : never;
interface CategoryProps {
    category: GetElementType<Props['schema']['categories']>
}
const Category: React.FC<PropsWithChildren<CategoryProps>> = ({ category }) => {
    const { t } = useTranslation();

    const CategoryLabel = () => <Label required
        label={t(`join-teacher-tribe:category.${category.title.toLowerCase()}`)}
        helpText={t(`join-teacher-tribe:category.${category.title.toLowerCase()}HelpText`, { defaultValue: '' })}
        name={category.id} />

    if (category.type === 'checkboxes') {
        return (
            <div className="mb-6">
                <CategoryLabel />
                {category.interests.map(interest => (
                    <CheckboxControl key={interest.id} name={`interests.${interest.id}`} color="black">
                        {t(`join-teacher-tribe:interests.${category.title.toLowerCase()}.${interest.name}`, { defaultValue: interest.name })}
                    </CheckboxControl>
                ))}
            </div>
        )
    }

    if (category.type === 'dropdown') {
        const options = category.interests.map(interest => ({
            label: interest.name,
            value: interest.id
        }))

        return (
            <div>
                <CategoryLabel />
                <SelectControl
                    name={`categories.${category.id}`}
                    placeholder='Select'
                    multiple
                    options={options}
                    value={[]}
                />
            </div>
        )
    }

    if (category.type === 'radio') {

        const options = category.interests.map(interest => ({
            label: interest.name,
            value: interest.id
        }))

        // return (
        //     <div>
        //         <CategoryLabel />
        //         <RadioGroupControl name="gender"
        //             options={options} />
        //     </div>
        // )

    }

    if (category.type === 'hidden') {
    }

    return null

}